/*
 * lib.tsx
 * build 生成 static/js/lib.js 共享给其他应用使用的入口文件
 * [externals]全局变量 weapp[模块名] => weappDemo, ESmodule => @weapp/demo
*/
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';

import EventEmitter from './utils/EventEmitter';
import { pcStores, mStores } from './store';

import RouteMain from './routes/pc/main';

import Loading from './components/common/pc/loading';
import MLoading from './components/mobile/mLoading';
import Relogin from './components/reloginDialog'
import * as API from './api/getListData';
import LayoutSDK from './utils/sdk';
import './style/lib.less'
import { CorsComponent, Dialog } from '@weapp/ui';
import { clearCookieByName, emLogout, getCookie, isProOrBetaEnv, needLayout } from './utils';
import { getAsyncHook, getLabel } from '@weapp/utils';

import "./components/main/navigation/accountInfo/style/index.less";
import "./components/main/navigation/style/index.less";
import "./components/main/appManage/style/index.less";
import "./components/main/navigation/widgets/QuickSearch/style/index.less";
import "./components/main/navigation/widgets/Tenantdrop/style/index.less";
import "./components/main/navigation/widgets/quickToolbar/style/index.less";
import "./components/main/navigation/widgets/quickToolbar/style/quickmenu.less";
import "./components/main/navigation/widgets/helpDrop/style/index.less";
import "./components/main/aside/menusSetting/style/index.less";
import "./components/inviteDialog/style/index.less";
import "./components/main/InviteWelfare/style/index.less";
import "./components/main/createTeams/style/index.less";
import "./components/main/defSetting/style/index.less";
import "./components/main/navigation/appmenus/AppMainMenus/style/index.less";
import "./components/feedback/style/index.less";
import "./components/common/pc/disabledModule/style/index.less";
import "./components/common/pc/displayModuleTip/style/index.less";
export { default as version } from "./libVersion";

const { confirm } = Dialog;

/* 导出库的样式文件，只在应用内使用不做共享的，请写在 style/index.less */

if (needLayout()) {
  window.inWeappLayout = true;
}

/* mobx 配置 */
configure({ enforceActions: 'always' });

/* 常量导出 */
export * as constants from './constants';
export * from './utils/jsAPI';
/*
 * 异步方式导出路由，路由中串联使用的组件，将一起被打包到路由下
 * 如非必要不要在 lib.tsx 同步引入路由串联组件，这样会导致修改重新更新 lib.js
 * 请不要对同一个文件在多处使用 import() 动态导入，会导致异步文件关系混乱
 * 打包生成路由单个 js 文件按照如下命名
*/
export const Main = React.lazy(() => import(
  /* webpackChunkName: "layout_PCFirstPage" */
  './components/main/index')) as any;
export const InviteDialog = React.lazy(() => import(
  /* webpackChunkName: "layout_PCFirstPage" */
  './components/inviteDialog/index')) as any;
export const TenantDialog = React.lazy(() => import(
  /* webpackChunkName: "router_TenantDialog" */
  './components/main/createTeams/index')) as any;
export const ReloginDialog = React.lazy(() => import(
  /* webpackChunkName: "router_ReloginDialog" */
  './components/reloginDialog/index')) as any;
export const FeedBackDialog = React.lazy(() => import(
  /* webpackChunkName: "layout_PCFirstPage" */
  './components/feedback/index')) as any;
export const AppDisplaySetting = React.lazy(() => import(
  /* webpackChunkName: "router_AppDisplaySetting" */
  './components/main/defSetting')) as any;
export const MobWorkBanch = React.lazy(() => import(
  /* webpackChunkName: "router_MobWorkBanch" */
  './components/mobile/workbanch/index'));
export const MobTeamsShare = React.lazy(() => import(
  /* webpackChunkName: "router_MobTeamsShare" */
  './components/mobile/teamsShare/index')) as any;
export const DemandDialog = React.lazy(() => import(
  /* webpackChunkName: "layout_PCFirstPage" */
  './components/demand/index')) as any;
export const DisabledModule = React.lazy(() => import(
  /* webpackChunkName: "layout_PCFirstPage" */
  './components/common/pc/disabledModule/index')) as any;
export const SystemErrorTip = React.lazy(() => import(
  /* webpackChunkName: "layout_PCFirstPage" */
  './components/common/pc/systemModuleTip/index')) as any;
export const DisplayModuleTip = React.lazy(() => import(
  /* webpackChunkName: "layout_PCFirstPage" */
  './components/common/pc/displayModuleTip')) as any;
export const UnInstallModuleTip = React.lazy(() => import(
  /* webpackChunkName: "layout_PCFirstPage" */
  './components/common/pc/unInstallModuleTip')) as any;



// 合并较小体积的chunck

export const TeamShareList = React.lazy(() => import(
  /* webpackChunkName: "component_pc" */
  './components/common/teamShareList/index')) as any;
export const RoleListPopup = React.lazy(() => import(
  /* webpackChunkName: "component_pc" */
  './components/main/navigation/widgets/Tenantdrop/role/index')) as any;
export const PrimaryAndSecondaryIdentity = React.lazy(() => import(
  /* webpackChunkName: "component_pc" */
  './components/common/pc/primaryAndSecondaryIdentity')) as any;
export const AppManage = React.lazy(() => import(
  /* webpackChunkName: "component_pc" */
  './components/main/appManage')) as any;
export const PCLockMask = React.lazy(() => import(
  /* webpackChunkName: "component_pc" */
  './components/page/lock/pc/index')) as any;
export const Page404 = React.lazy(() => import(
  /* webpackChunkName: "component_pc"
  * */"./components/page/page404/index"));
export const LayoutLogin = React.lazy(() => import(
  /* webpackChunkName: "component_pc" */
  "./components/page/login/index"));


export const MobMainFrame = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/index'));
export const MRoleList = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/workbanch/Teams/role')) as any;
export const MobRecommend = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/workbanch/Recommend')) as any;
export const MobInvite = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/invite/index')) as any;
export const MCreateTeam = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/workbanch/createTeam')) as any;
export const MobPersonalCenter = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/workbanch/PersonalCenter'));
export const MobSet = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/workbanch/Set')) as any;
export const MobAppQrcode = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/appQrcode/index')) as any;
export const MPrimaryAndSecondaryIdentity = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/common/m/primaryAndSecondaryIdentity')) as any;
export const MobApplications = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/workbanch/Applications'));
export const MobTeams = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/workbanch/Teams')) as any;
export const MobAppManage = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/appManage/index')) as any;
export const MobRecords = React.lazy(() => import(
  /* webpackChunkName: "component_mobile" */
  './components/mobile/workbanch/Recommend/records')) as any;
export const MobTeamShareList = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/common/m/mobTeamsShareList/index')) as any;


export const MobRule = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/mobile/workbanch/Recommend/rule')) as any;
export const MIdentitySetting = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/mobile/identitySetting/index')) as any;
export const MQuickCreate = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/mobile/workbanch/quickCreate/QuickMenu')) as any;
export const MobFeedback = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/mobile/workbanch/Feedback')) as any;
export const MobAppDownload = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/mobile/appDownload/index')) as any;
export const MobDisabledModule = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/common/m/disabledModule/index')) as any;
export const MobAppLogin = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/mobile/appLogin/index')) as any;
export const MDisplayModuleTip = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/common/m/displayModuleTip')) as any;
export const MobNoPermission = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/page/noPermission/index')) as any;
export const MobSubscribeTransfer = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/mobile/subscribeTransfer/index')) as any;
export const MobSystemErrorTip = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/common/m/disabledModuleNew/index')) as any;
export const MunInstallModuleTip = React.lazy(() => import(
  /* webpackChunkName: "component_mobile2" */
  './components/common/m/displayModuleTipNew')) as any;

export { default as RouteMain } from './routes/pc/main';
export { default as RouteMobPersonalCenter } from './routes/mobile/me';
export { default as RouteMobWorkBench } from './routes/mobile/workbench';
export { default as RouteMobAppication } from './routes/mobile/application';
export { default as RouteMobAppManage } from './routes/mobile/appManage';
export { default as RouteMobFeedback } from './routes/mobile/feedback';
export { default as RouteMobRecommend } from './routes/mobile/recommend';
export { default as RouteMobRule } from './routes/mobile/rule';
export { default as RouteMobRecord } from './routes/mobile/records';
export { default as RouteMobTeams } from './routes/mobile/teams';
export { default as RouteMobTeamsShare } from './routes/mobile/teamsShare';
export { default as RouteMobInvite } from './routes/mobile/invite';
export { default as RouteMobAppQrcode } from './routes/mobile/appQrcode';
export { default as RouteMobAppLogin } from './routes/mobile/appLogin';
export { default as RouteMobSet } from './routes/mobile/set';
export { default as RouteMobCreateTeam } from './routes/mobile/createTeam';
export { default as RouteMobAppDownload } from './routes/mobile/appDownload';
export { default as RouteMobTeamsShareList } from './routes/mobile/appshare';
export { default as RouteMobSubscribeTransfer } from './routes/mobile/subscribeTransfer';
export { default as RouteMobDisabledModule } from './routes/mobile/disabledModule';
export { default as RouteLayoutRedirect } from './routes/pc/layoutRedirect';
export { default as MSpaceNoPermission } from './routes/mobile/spaceNoPermission';
export { default as RouteMobDisplayModuleTip } from './routes/mobile/displayModuleTip';
export { default as RouteMobUnlock } from './routes/mobile/mUnlock';
export { default as RouteQuickCreate } from './routes/mobile/quickCreate';
export { default as RouteIdentitySetting } from './routes/mobile/identitySetting';
export { default as RouteQuickCreateTest } from './routes/mobile/quickCreateTest';
/*
 * 同步导出业务组件，
 * 如非必要不要在 lib.tsx 同步引入路由串联组件，这样会导致修改重新更新 lib.js
*/
export { default as Loading } from './components/common/pc/loading';
export { default as ModuleLoading } from './components/common/pc/moduleLoading';

/*
 * 默认导出 store 共享
 * 由于 store 需要同步注入，这样会导致修改重新更新 lib.js
*/
export { pcStores, mStores };

const { mainStore } = pcStores;
const { mobTeamsStore } = mStores;
export { mainStore };
export { LayoutSDK };
// const LayoutSDK = window.weappLayout?.LayoutSDK || new LayoutSDKCom()
/* 导航store */
export * as navigationStore from './components/main/navigation/store';
export {
  AccountInfoCom, AppDropMenusCom, QuickSearchCom, TenantDropCom, QuickMenusCom, FastCreateMenusCom, CountTabCom, HelpDropCom, MenuSettingDialogCom,
  TenantsDialogCom, WxchatCom, TerminalCom, TerminalDialogCom, InviteDialogCom, ClearCacheDialogCom, AppDisplaySettingDialogCom, AppMainMenusCom, QuickToolBarCom, InviteWelfareDialogCom
} from './components/main/navigation/exportCompents';
export { cusAppModules } from './constants/index';
const ee = window.weappLayout?.ee || new EventEmitter();

/**
 * data:{type:'pc',employeeId:xxx,tenantKey:xxx}
 */

const eventEmitterControl = () => {//控制事件不多次注册
  if (!ee?._events?.['layout.logout']) {
    ee.on('layout.logout', (needConfirm?: any) => {//登出
      const logout = () => {
        mainStore?.refreshEmployee();
        if (window.ePassport?.logout) {
          //登录前钩子
          const hook = getAsyncHook('weappLayout', 'beforeLogout');
          if (hook) {
            hook(0)
          }
          window.ePassport.logout(() => {
            const hook = getAsyncHook('weappLayout', 'afterLogout');
            if (hook) {
              hook(0)
            }
          });
        }
      }
      if (needConfirm) {
        confirm({
          content: getLabel('62187', '确定退出登录吗？'),
          onOk: () => {
            emLogout();
            logout();
          }
        });

      } else {
        logout();
      }
    });
  }
  if (!ee?._events?.['layout.changeTenant']) {
    ee.on('layout.changeTenant', (data: any) => {//创建团队设置弹出
      if (data.type === 'pc') {
        mainStore?.changeTeam(data);
      } else if (data.type === 'h5') {
        mobTeamsStore?.changeTeam(data);
      }
    });
  }

}
eventEmitterControl();

const freeTimeLoad = () => {
  //延迟10s触发闲时加载部分
  const isSpecialTheme = window.TEAMS?.theme?.themeType === 'feature';
  setTimeout(() => {
    LayoutSDK.doFreeTimeLoad();
  }, isSpecialTheme ? 0 : 10000)
}

//闲时加载触发
freeTimeLoad();

const appMenuItemClick = window.weappLayout?.['evt.appMenuItemClick'];
const quickMenuItemClick = window.weappLayout?.['evt.quickMenuClick'];
export { ee, appMenuItemClick, quickMenuItemClick };
const stores = {
  ...pcStores,
  ...mStores
}

const mob_stores = {
  ...mStores
}


// 导出单页框架
export function MainComs(props: any) {
  return <Provider weId={`67vxss`} {...stores}>
    <Suspense weId={`gqkp27`} fallback={<Loading weId={`iyx2ls`} />}>
      <RouteMain weId={`aij8n3`} >
        {props.children}
      </RouteMain>
    </Suspense>
  </Provider>
}

// 导出多页框架
export function SpaComs(props: any) {
  return <Provider weId={`67vxss`} {...stores}>
    <Suspense weId={`gqkp27`} fallback={<Loading weId={`iyx2ls`} />}>
      <RouteMain weId={`aij8n3`} isSpPage={true}>
        {props.children}
      </RouteMain>
    </Suspense>
  </Provider>
}

// 导出多页框架
export function SpComs(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`gqlp27`} fallback={<Loading weId={`iyx4ls`} />}>
      <RouteMain weId={`aih8n7`} isSpPage={true}>
        {props.children}
      </RouteMain>
    </Suspense>
  </Provider>
}
// // 加入创建团队
// export function TenantsDialogCom(props: any) {
//   return <Provider weId={`67vxds`} {...stores}>
//     <Suspense weId={`gqlp27`} fallback={<></>}>
//       <TenantDialog weId={`aih8n7`}  {...props} />
//     </Suspense>
//   </Provider>
// }
//团队分享列表组件
export function TeamSharingListModule(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`gqlp27`} fallback={<Loading weId={`iyx4ls`} />}>
      <TeamShareList weId={`${props.weId || ''}_jah7gy`} {...props} />
    </Suspense>
  </Provider>
}

//H5团队分享列表组件
export function MobTeamSharingListModule(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`gqlp27`} fallback={<Loading weId={`iyx4ls`} />}>
      <MobTeamShareList weId={`${props.weId || ''}_jah7gy`} {...props} />
    </Suspense>
  </Provider>
}


//H5团队分享组件
export function MobTeamSharingModule(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`gqlp27`} fallback={<Loading weId={`iyx6ls`} />}>
      <MobTeamsShare weId={`${props.weId || ''}_jah7gy`} {...props} />
    </Suspense>
  </Provider>
}
//付费提示组件
export function DisplayModuleTipCom(props: any) {
  return <Suspense weId={`gqlp27`} fallback={<></>}>
    <DisplayModuleTip weId={`${props.weId || ''}_jah7gy`} {...props} />
  </Suspense>
}
export function PurchasedModuleTipCom(props: any) {
  return <Suspense weId={`gqlp27`} fallback={<></>}>
    <DisplayModuleTip weId={`${props.weId || ''}_jah7gy`} {...props} />
  </Suspense>
}

//模块禁用提示组件
export function DisabledModuleTipCom(props: any) {
  return <Suspense weId={`${props.weId || ''}_1jt57a`} fallback={<></>}>
    <DisabledModule weId={`${props.weId || ''}_xfo2am`} {...props} />
  </Suspense>
}

//pc锁定界面
export function PCLockMaskCom(props: any) {
  return <Suspense weId={`_3l0hpf`} fallback={<></>}>
    <PCLockMask weId={`_mq7njq`} {...props} />
  </Suspense>
}

export function QuickCreateCom(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`_3l0hpf`} fallback={<></>}>
      <MQuickCreate weId={`_mq7njq`} {...props} />
    </Suspense>
  </Provider>
}

//重登mobMainStore
export function relogin() {
  if (window.layoutIsShowRelogin || window.forbidReloginDialog) {
    return
  }
  window.layoutIsShowRelogin = true;
  const caslogouturl = sessionStorage.getItem('E10_CASLOGOUTURL');
  // clearCookieByName('CASTGC');
  // if (getCookie('CASTGC')) {
  //   window.location.href = `${publicUrlapi}/papi/sso/server/logout?tk=${window.TEAMS?.currentTenant?.tenantKey}`;
  // } else
  if (caslogouturl) {
    clearCookieByName('caslogouturl');//临时兜底
    sessionStorage.removeItem('E10_ETEAMSID');
    sessionStorage.removeItem('E10_CASLOGOUTURL');
    // API.loginLogRecord().then(() => {
    API.clearCookie().then(() => {
      window.location.href = caslogouturl;
    })
    // })
  } else {
    if (!document.querySelector('#reloginDialog')) {
      const div = document.createElement('div');
      div.setAttribute('id', 'reloginDialog');
      document.body.appendChild(div);
      ReactDOM.render(
        <Provider weId={`67vxds`} {...stores}>
          <Relogin weId={`_irbzcs`} /></Provider>, div);
    }
  }
}

//左侧菜单设置esb
export function esbMenuSettingCom(props: any) {
  return <CorsComponent weId={`${props.weId || ''}_lfe0xv`} app='@weapp/cusapp' compName="SetSearchDialogComp"  {...props} />
}

//主次身份切换组件
export function RoleListPopupCom(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`_3l0hpf`} fallback={<></>}>
      <RoleListPopup weId={`_mq7njq`} {...props} />
    </Suspense>
  </Provider>
}

//h5显示主次身份切换
export function showRoleChangeActionSheet(callback?: (role: any) => void) {
  MRoleList._payload._result().then((res: any) => {
    res?.default?.showRoleChangeActionSheet?.(callback)
  })
}